module.exports = __webpack_public_path__ + "static/media/landing_bottom.050db2dd.svg";